import { saveStorageData } from 'app/utils/localStorage/localStorage';
import { isEmpty } from 'lodash';
import { customFetch, isJsonString } from './ajaxHelpers';
import { REMOVE_FOOTER_INVISIBILITY } from '../cmscomponents/footer/footerConstants';

const { loggedUserInfoUrl, pageType, baseStoreUrl, locale } = window.inlineGlobalConfig;

window.globalData = window.globalData || {};

window.globalData.cartInfo =
  window.globalData.cartInfo ||
  (() => {
    let resolveCartInfoPromise = null;
    const data = new Promise(resolve => {
      resolveCartInfoPromise = resolve;
    });
    return {
      set(cartInfo) {
        resolveCartInfoPromise(cartInfo);
      },
      get() {
        return data;
      },
    };
  })();

export function setGlobalCartInfo(cartInfo) {
  window.globalData.cartInfo.set(cartInfo);
  return cartInfo;
}

export function getGlobalCartInfo() {
  return window.globalData.cartInfo.get();
}

// TOOD: Refactor to merge with cartInfo
// -----------------------------------------
window.globalData.wishlistInfo =
  window.globalData.wishlistInfo ||
  (() => {
    let setInfo;
    let hasBeenSet = false;
    let pendingResolves = [];
    return {
      set(wishlistInfo) {
        setInfo = wishlistInfo;
        hasBeenSet = true;
        if (pendingResolves.length) {
          const resolves = pendingResolves;
          pendingResolves = [];
          resolves.forEach(resolve => resolve(setInfo));
        }
      },
      get() {
        if (hasBeenSet) {
          return Promise.resolve(setInfo);
        }
        return new Promise(resolve => {
          pendingResolves.push(resolve);
        });
      },
      hasData() {
        return hasBeenSet;
      },
    };
  })();

export function setGlobalWishlistInfo(wishlistInfo) {
  // Backend can return { wishlist: {} } when wishlist.name is missing, which loses the entries array.
  // Only overwrite the global store with properly-shaped responses; otherwise preserve previously-good data.
  // If no data has been stored yet, normalize the malformed response so callers don't wait forever.
  const hasValidShape = wishlistInfo && wishlistInfo.wishlist && Array.isArray(wishlistInfo.wishlist.entries);

  if (hasValidShape) {
    window.globalData.wishlistInfo.set(wishlistInfo);
  } else if (!window.globalData.wishlistInfo.hasData()) {
    const normalized = {
      ...(wishlistInfo || {}),
      wishlist: { ...((wishlistInfo && wishlistInfo.wishlist) || {}), entries: [] },
    };
    window.globalData.wishlistInfo.set(normalized);
  }
  return Promise.resolve(wishlistInfo);
}

export function getGlobalWishlistInfo() {
  return window.globalData.wishlistInfo.get();
}
// -----------------------------------------

export function getLoggedUserInfo() {
  if (!window.globalData.loggedUserInfo) {
    window.globalData.loggedUserInfo = customFetch('GET', `${loggedUserInfoUrl}&_=${Date.now()}`).then(
      xhttp =>
        new Promise((resolve, reject) => {
          /* eslint-disable no-param-reassign */
          xhttp.onload = () =>
            resolve(isJsonString(xhttp.responseText) ? JSON.parse(xhttp.responseText) : xhttp.responseText);
          xhttp.onerror = () => reject(xhttp.statusText);
          /* eslint-enable no-param-reassign */
        })
    );
  }
  return window.globalData.loggedUserInfo;
}

export function isGuestUser() {
  return getLoggedUserInfo().then(userInfo => isEmpty(userInfo['userInfo/index'].username));
}

export function getBaseStoreData() {
  if (!window.globalData.baseStoreData) {
    window.globalData.baseStoreData = customFetch('GET', baseStoreUrl).then(
      xhttp =>
        new Promise((resolve, reject) => {
          /* eslint-disable no-param-reassign */
          xhttp.onload = () =>
            resolve(isJsonString(xhttp.responseText) ? JSON.parse(xhttp.responseText) : xhttp.responseText);
          xhttp.onerror = () => reject(xhttp.statusText);
          /* eslint-enable no-param-reassign */
        })
    );
  }
  return window.globalData.baseStoreData;
}

export function getCurrentStoreData() {
  return getBaseStoreData().then(baseStore =>
    baseStore.stores.find(store => store.uid === locale.country.toUpperCase())
  );
}

export function displayFooter() {
  window.globalData.isFooterDisplayed = window.globalData.isFooterDisplayed || false;

  if (!window.globalData.isFooterDisplayed) {
    const footer = document.querySelector('.footer');

    if (footer) {
      footer.classList.remove('invisible');
    } else {
      saveStorageData(REMOVE_FOOTER_INVISIBILITY, 'true');
    }

    if (pageType === 'bag') {
      try {
        const $mediaBanner = document.querySelector('.cart__media-banner');
        if ($mediaBanner) {
          $mediaBanner.classList.remove('invisible');
        }
      } catch (e) {
        console.error(e);
      }
    }

    window.globalData.isFooterDisplayed = true;
  }
}

export function waitPageLoadAnalytics() {
  if (!window.globalData.isPageAnalyticsPushed) {
    window.globalData.isPageAnalyticsPushed = new Promise(resolve => {
      if (isPageLoadAnalyticsPushed()) {
        resolve();
      } else {
        setInterval(() => {
          if (isPageLoadAnalyticsPushed()) {
            resolve();
          }
        }, 200);
      }
    });
  }
  return window.globalData.isPageAnalyticsPushed;
}

function isPageLoadAnalyticsPushed() {
  for (let i = 0; i < window.dataLayer.length; i++) {
    if (window.dataLayer[i].ga_account) {
      return true;
    }
  }
  return false;
}

const NOTIFY_ME_CLEARANCE_STATUSES_FALLBACK = ['Full Price'];

let notifyMeClearanceStatuses = NOTIFY_ME_CLEARANCE_STATUSES_FALLBACK;

export function loadNotifyMeClearanceStatuses() {
  if (!window.globalData.notifyMeClearanceStatuses) {
    window.globalData.notifyMeClearanceStatuses = getCurrentStoreData()
      .then(currentStore => {
        if (currentStore) {
          notifyMeClearanceStatuses = currentStore.productNotifyInStockDisplayedClearanceStatuses || [];
        }
        return notifyMeClearanceStatuses;
      })
      .catch(error => {
        console.error('Unable to load notify me clearance statuses', error);
        return notifyMeClearanceStatuses;
      });
  }
  return window.globalData.notifyMeClearanceStatuses;
}

export function getNotifyMeClearanceStatuses() {
  return notifyMeClearanceStatuses;
}
